// cs2586 (29/09/2026): "manter o topo do site da home nas demais páginas". Os topos 5 (Clean central),
// 6 (Editorial fixo) e 7 (Flutuante) só existiam na home; as páginas internas caíam no Topo clássico.
// Com a opção ligada, os cabeçalhos das internas (WelcomePiecesCompany e WelcomePiecesProperties)
// usam o mesmo topo da home. Sem a opção, NADA muda (diff nulo nos ~300 sites).
// Opção: `site.topo_home_nas_internas` (botão no CRM, em Personalizar site › Comportamento) — a
// allowlist abaixo é o fallback até o campo existir no site-graphql.
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';

const TopoCentral = dynamic(() => import('../components/pieces/topo-central/TopoCentral'), { ssr: true });
const TopoEditorial = dynamic(() => import('../components/pieces/topo-editorial/TopoEditorial'), { ssr: true });
const TopoModerno = dynamic(() => import('../components/pieces/topo-moderno/TopoModerno'), { ssr: true });

export const TOPO_HOME_NAS_INTERNAS = new Set<number>([2586]);

const TOPO_HOME_POR_MODELO: Record<number, ComponentType<any>> = {
    5: TopoCentral,
    6: TopoEditorial,
    7: TopoModerno,
};

/** Topo da home para as páginas internas, ou undefined (= cabeçalho de sempre). */
export function topoDaHomeNasInternas(site: any): ComponentType<any> | undefined {
    const ligado = site?.topo_home_nas_internas === true || TOPO_HOME_NAS_INTERNAS.has(Number(site?.id));
    return ligado ? TOPO_HOME_POR_MODELO[Number(site?.modelo_topo)] : undefined;
}
